module.exports = __webpack_public_path__ + "static/media/huli_407.ccfd9a2e.jpg";